module.exports = "https://bin.bnbstatic.com/_next/static/images/binance life 1-b05c2c164edbc2d55e271eeae71635c7.jpg";